import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './ZoomOutTextEffect.css';

const ZoomOutTextEffect = ({ children, className = '' }) => {
  const containerRef = useRef(null);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  // Transform values for text zoom and opacity effects
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.2, 1.1, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.5, 0.8, 1]);
  const y = useTransform(scrollYProgress, [0, 0.5, 1], [20, 10, 0]);

  return (
    <div ref={containerRef} className={`zoom-out-text-container ${className}`}>
      <motion.div 
        className="zoom-out-text-content"
        style={{ 
          scale,
          opacity,
          y
        }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default ZoomOutTextEffect;
